module.exports = __webpack_public_path__ + "img/full6-min.77f3c31a.png";